import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const QUERY = gql`
  query WorkspaceAssociatedResources($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          associatedResources {
            ...PerformanceCenterCustomerResource
          }
        }
      }
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

export const queryWorkspaceAssociatedResources = async ({ customerId, id }, options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { customerId, id },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp(result.data);
  return data?.edges[0]?.node?.associatedResources || [];
};
